/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.7.1 of "Payments service"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */

export type SecondaryConnection = {
    /**
     * Secondary receiver identifier ID value.
     */
    id?: string;
    type?: SecondaryConnection.type;
};

export namespace SecondaryConnection {

    export enum type {
        PHONE = 'PHONE',
        EMAIL = 'EMAIL',
        TAX_ID = 'TAX_ID',
        TAX_NO = 'TAX_NO',
        PAN = 'PAN',
        UNKNOWN = 'UNKNOWN',
    }


}

